export default [
  {
    name: 'reports',
    path: '/reports',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Relatórios',
      icon: 'dvr',
      label: 'Relatórios',
      roles: ['Admin']
    },
    children: [
      { path: '/reports/participants', component: () => import(/* webpackChunkName: "event" */ './participants/Index.vue'), name: 'report-participants', meta: { roles: ['Admin'] } },
      { path: '/reports/participantsAir', component: () => import(/* webpackChunkName: "event" */ './participantsAir/Index.vue'), name: 'report-participantsAir', meta: { roles: ['Admin'] } },
      { path: '/reports/participantsCompanions', component: () => import(/* webpackChunkName: "event" */ './participantsCompanions/Index.vue'), name: 'report-participantsCompanions', meta: { roles: ['Admin'] } },
      { path: '/reports/participantsPayments', component: () => import(/* webpackChunkName: "event" */ './participantsPayments/Index.vue'), name: 'report-participantsPayments', meta: { roles: ['Admin'] } },
      { path: '/reports/galistas', component: () => import(/* webpackChunkName: "event" */ './participantsGalistas/Index.vue'), name: 'report-galistas', meta: { roles: ['Admin'] } },
      { path: '/reports/guests', component: () => import(/* webpackChunkName: "event" */ './guests/Index.vue'), name: 'report-guests', meta: { roles: ['Admin'] } },
      { path: '/reports/leadCollection', component: () => import(/* webpackChunkName: "event" */ './leadCollection/Index.vue'), name: 'report-leadCollection', meta: { roles: ['Admin'] } },
      { path: '/reports/participantsFinancials', component: () => import(/* webpackChunkName: "event" */ './participantsFinancials/Index.vue'), name: 'report-participantsFinancials', meta: { roles: ['Admin'] } }
    ]
  }
]
